/** Compact home page news feed, one year at a time. */
import React, { useState } from 'react';
import * as styles from './homePage.module.less';

// Newest first; an entry with several items is shown as a group.
const NEWS = [
    {
        date: '2026/10',
        items: [
            <>I made <strong><a href="/looped-model-atlas/">Looped Model Atlas</a></strong>, an interactive walk through looped-model designs. Give it a play!</>,
            <><strong><a href="https://arxiv.org/abs/2610.06833">Part II of Towards Looped Models Done Right</a></strong> reached <strong><a href="https://www.alphaxiv.org/abs/2610.06833">#1 on alphaXiv</a></strong>.</>,
        ],
    },
    {
        date: '2026/04',
        items: [
            <>Two papers (<strong><a href="https://arxiv.org/abs/2605.21488v1">EqR</a></strong> and <strong><a href="https://arxiv.org/abs/2601.01075">FloWM</a></strong>) are accepted to <strong>ICML 2026</strong>. See you in Seoul!</>,
            <><strong><a href="https://github.com/huskydoge/Awesome-Loop-Models">Awesome Loop Models</a></strong> is released: a curated list and interactive browser for loop-model papers and technical blogs.</>,
        ],
    },
    {
        date: '2026/01',
        items: [<>The code of <strong><a href="https://github.com/hlillemark/flowm">Flow Equivariant World Models</a></strong> is released.</>],
    },
    {
        date: '2025/11',
        items: [<>Tech report of <strong><a href="https://panworld.ai/">PAN World Model</a></strong> is released.</>],
    },
    {
        date: '2025/07',
        items: [<><strong><a href="https://blog.dynamicslab.ai/">Magica</a>, a Generative World Engine, </strong> is now available online.</>],
    },
    {
        date: '2025/05',
        items: [<><strong>DCA-Bench</strong> has been accepted to <strong>KDD 2025</strong> DB-Track as an <strong>oral paper</strong>.</>],
    },
];
const YEARS = [...new Set(NEWS.map(n => n.date.slice(0, 4)))];


/** Render the home page news feed with a tab per year. */
const News = () => {
    const [year, setYear] = useState(YEARS[0]);
    return (
        <div className={styles.homepageSection}>
            <div className={styles.sectionHeading}>
                <h2>News</h2>
                <div className={styles.newsTabs} role="tablist" aria-label="News by year">
                    {YEARS.map(y => (
                        <button key={y} type="button" role="tab" aria-selected={y === year}
                            className={y === year ? styles.newsTabOn : styles.newsTab} onClick={() => setYear(y)}>
                            {y}
                        </button>
                    ))}
                </div>
            </div>
            <ul className={styles.newsList}>
                {NEWS.filter(n => n.date.startsWith(year)).map(n => (
                    <li key={n.date} className={styles.newsItem}>
                        <span className={styles.newsDate}>{n.date}</span>
                        {n.items.length > 1 ? (
                            <div className={`${styles.newsContent} ${styles.newsContentGrouped}`}>
                                <ul className={styles.newsContentList}>
                                    {n.items.map((item, k) => <li key={k}>{item}</li>)}
                                </ul>
                            </div>
                        ) : (
                            <div className={styles.newsContent}>{n.items[0]}</div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default News;
